<template>
	<div>		
		<div class="col-sm-6">
			<input type="hidden" class="rating current-product pull-left" data-filled="fa fa-star item-rate-yellow item-rate" data-empty="fa fa-star item-rate-gray item-rate" data-readonly :value="render_rate"/>
			<br>
			<div class="flexible">
				<span class="text-blue pointer" data-toggle="modal" data-target="#modal-view-comments">Ver Comentarios</span>
				<modal-view-comments :ratings="render_ratings" :rate="render_rate"></modal-view-comments>
				<p class="text-reviews" style="padding-top: 0;">({{ render_ratings.length }} reseñas)</p>
			</div>		     	
		</div>
		<div class="col-sm-6">
			<button v-if="user.token" type="button" class="btn btn-link text-uppercase" data-toggle="modal" data-target="#modal-add-rate">
			  Añadir calificación
			</button>
			<modal-add-rate></modal-add-rate>
		</div>
	</div>
</template>

<style scoped>
	.flexible{
		display: flex;
	}
	.col-sm-6 .btn-link{
		padding-top: 15px;
		white-space: normal;
		color: black;
		padding-bottom: 0;
	}
	@media(max-width: 768px){
		.col-sm-6 .btn-link{
			padding: 0 15px;
		}
	}
</style>

<script>
import ModalViewComments from '../Modals/Modal-view-comments.vue';
import ModalAddRate from '../Modals/Modal-add-rate.vue';

export default {
	props: ['rate', 'ratings'],

	vuex: {
		getters: {
			user: state => state.current_user
		}
	},

	computed: {
		render_rate () {
			// if the rate is null set this to 0,
			// to solve an issue.
			if (!this.rate) {
				this.rate = 0;
			}

			$('.current-product').rating('rate', this.rate);
			return this.rate;
		},

		render_ratings () {
			return this.ratings;
		}
	},

	components: {
		ModalViewComments,
		ModalAddRate,
	}
}
</script>


// WEBPACK FOOTER //
// Product-detail-rate.vue?0cfa91fe